export const LARGE_SCREEN_SIZE = 600;
export const AXIOS_TIMEOUT = 30000;

export const ADMIN_ROLES = ['super-admin', 'owner', 'admin'];
export const USER_ROLES = ['user'];

export const LOCAL_STORAGE_KEY = 'local';
export const SERVER_ERR_MSG = 'Server Error!';

export const STORAGE_URL =
  'https://screenkode-storage.nyc3.digitaloceanspaces.com';
export const ORGANIZATION_LOGO_DIR = 'documents/organization_logos';
export const SCREEN_IMAGES_DIR = 'documents/screen_images'
export const INVOICES_DIR = 'documents/invoices';

// The Screenkode app, where screens play — chosen the way api/base.ts chooses
// the server: local development, the dev site (a "dev." host) or production.
export const APP_URL = (
  (process.env.NODE_ENV === 'development'
    ? process.env.VUE_APP_LOCAL_APP_URL
    : window.location.hostname.startsWith('dev.')
      ? process.env.VUE_APP_DEV_APP_URL
      : process.env.VUE_APP_APP_URL) || 'https://app.screenkode.com'
).replace(/\/+$/, '');

// The Chabad Digital app, where organizations that use it instead of Screenkode
// sign in and play their screens. Chosen like APP_URL.
export const CHABAD_APP_URL = (
  (process.env.NODE_ENV === 'development'
    ? process.env.VUE_APP_LOCAL_CHABAD_APP_URL
    : window.location.hostname.startsWith('dev.')
      ? process.env.VUE_APP_DEV_CHABAD_APP_URL
      : process.env.VUE_APP_CHABAD_APP_URL) || 'https://app.chabaddigital.com'
).replace(/\/+$/, '');

// Mirrors what the organization route accepts before it uploads to storage,
// so a bad pick is caught here instead of coming back as a 400.
export const ALLOWED_LOGO_MIMETYPES = ['image/jpeg', 'image/png'];
export const MAX_LOGO_FILE_SIZE = 2 * 1024 * 1024;

export const SUBSCRIPTION_PERIOD_MONTHLY = 'monthly';
export const SUBSCRIPTION_PERIOD_YEARLY = 'yearly';

export const DEFAULT_ERROR_MSG = 'Error! Something went wrong.';
export const TOAST_GLOBAL_CONFIG = { position: 'top-right', dismissible: true };

export const DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

export const DATETIME_OPTIONS: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
};

export const SCREEN_ARTBOARD_FEATURES = [
  'Donation',
  'Announcement',
  // Shiurei Torah. The token must stay exactly 'ShiureiTorah': the app's
  // display, its artboard picker and the public API all match on it.
  'ShiureiTorah',
  // 'Minyunim',
  // 'MinyunimCountdown',
  'MinyanRoll',
  // 'Zmanim',
  'Zmanim_N',
  // 'Yurtzeiten',
  'Yurtzeiten_N',
  'RecentPhoto',
  'Event',
  'Poster',
  'DateTimeBanner',
  'WeeklyEvent',
  // The Weekly Schedule board (Chabad Digital). Ticking it is what puts the
  // board on the artboard; the app's Weekly Schedule page sets its routing.
  'WeeklySchedule_N',
  'PhotoUnderline',
  'UpcomingMinyanim'
]

export const TICKET_STATUS_OPEN = 'open'
export const TICKET_STATUS_CLOSED = 'closed'

export const TICKET_COMMENT_TYPES = [
  'ticket-close',
  'ticket-reopen',
  'ticket-comment'
]

// The longest a ticket's subject may be — what the API takes when it is renamed.
export const TICKET_SUBJECT_MAX_LENGTH = 200;

// Files sent with a ticket or a message. Mirrors what the API's ticket routes
// accept before uploading to storage (its utils/ticket_upload), so a bad pick
// is caught here instead of coming back as a 400.
export const TICKET_ATTACHMENTS_DIR = 'documents/ticket_attachments';
export const TICKET_ATTACHMENT_MAX_FILES = 5;
export const TICKET_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;
export const TICKET_ATTACHMENT_EXTENSIONS = [
  '.jpg', '.jpeg', '.png', '.gif', '.webp', '.heic',
  '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.csv', '.txt', '.rtf',
  '.zip', '.mp4', '.mov', '.webm', '.log', '.json',
];

// How often the app asks what is unread (the badge on Tickets in the navs),
// and how often an open conversation checks for new messages.
export const TICKET_UNREAD_POLL_MS = 30 * 1000;
export const TICKET_THREAD_POLL_MS = 6 * 1000;
